
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function CTASection() {
  return (
    <section className="relative py-20 overflow-hidden">
      {/* Red Background */}
      <div className="absolute inset-0 bg-red-600"></div>
      
      {/* Background Pattern */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url("https://static.readdy.ai/image/dc2d8628d8f3138a616830da3589deda/6964c53d883724af92f6569f0b92a70f.jpeg")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      ></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 hero-text-shadow">
            Ready to Secure Your Property?
          </h2>
          
          <p className="text-xl text-gray-100 mb-8 hero-text-shadow">
            Get a free consultation and quote for your fire safety needs. 
            Our experts are standing by to help protect what matters most.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button className="font-medium rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer min-h-[44px] flex items-center justify-center bg-white text-red-600 hover:bg-gray-100 border-2 border-white hover:border-gray-100 px-8 py-4 text-lg transform hover:scale-105">
              <i className="ri-phone-line mr-2"></i>
              Call Now: +966 11 234 5678
            </button>
            <button className="font-medium rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer min-h-[44px] flex items-center justify-center bg-transparent text-white border-2 border-white hover:bg-white hover:text-red-600 px-8 py-4 text-lg transform hover:scale-105">
              <i className="ri-mail-line mr-2"></i>
              Request Free Quote
            </button>
          </div>
          
          {/* Emergency Notice */}
          <div className="mt-8 p-4 bg-white/10 backdrop-blur-sm rounded-lg border border-white/20">
            <div className="flex items-center justify-center space-x-3 text-white">
              <i className="ri-alarm-warning-line text-2xl text-yellow-300"></i>
              <span className="font-semibold">24/7 Emergency Response Available</span>
              <i className="ri-phone-line text-xl text-green-300"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
